import { request, user, debug } from 'lib';
import { globalStore, getGlobalStore } from 'stores';
import room from './room';
import { UiToast, UiModal } from 'components';

const log = debug.create('auth');

let forbidEndTime = 0;
let forbidStatus = false; // 厅禁言

const init = () => {
  if (user.isLogin()) {
    initStatus();
  }
};

const initStatus = () => {
  request.api
    .get(`user/shutup_ttl/{access_token}/${room.getRoomId()}`)
    .then((res) => {
      forbidEndTime = res.data.ttl
        ? new Date().getTime() + res.data.ttl * 1000
        : 0;
    });

  request.api
    .get(`user/kick_ttl/{access_token}/${room.getRoomId()}`)
    .then((res) => {
      // kickOutTip();
    });

  if (room.getRoomType() === 6) {
    request.funny
      .get(`/api/v1/multiRoom/userLimit`, {
        roomId: room.getRoomId(),
      })
      .then((res) => {
        if (res.data.block || res.data.kick) {
          const tips = res.data.block
            ? '您已经被拉黑,3秒后回到首页'
            : '您已经被踢出派对,3秒后回到首页';
          kickOutTip(tips);
          return;
        }
        if (res.data.shutup) {
          forbidStatus = true;
        }
      });
  }
};

const kickOutTip = (tips) => {
  UiToast.fail(
    tips,
    () => {
      location.href = '/';
    },
    3000,
  );
};

const isForbid = () => {
  log('isForbid', forbidEndTime, Date.now() < forbidEndTime);
  if (room.getRoomType() === 6) {
    return forbidStatus;
  }
  return Date.now() < forbidEndTime;
};

const isKickOut = () => {};

const updateForbidTime = (time) => {
  log('updateForbidTime', time);
  forbidEndTime = time;
};

const updateForbidStatus = (status) => {
  log('updateForbidStatus', status);
  forbidStatus = status;
};

/**
 * 多人厅操作
 * @param {*} operator 操作类型  block-拉黑 shutup-禁言 kick-踢出房间
 * @param {*} uid 被执行禁言，拉黑，踢出房间的用户id
 * @returns
 */
const handleHostOperator = (operator, uid) => {
  if (!operator || !uid) {
    return;
  }
  return request.funny
    .get('/api/v1/multiRoom/hostOperator', {
      roomId: room.getRoomId(),
      uid,
      operator,
    })
    .then(() => {
      UiToast.success('操作成功');
    })
    .catch((err) => {
      UiToast.fail(err.msg || '操作失败');
      return Promise.reject(err);
    });
};

const forbid = (userId, minute) => {
  request.cryolite
    .post(`api/v2/privileges/shutup`, {
      to_id: userId,
      room_id: room.getRoomId(),
      minutes: minute,
    })
    .then((res) => {
      UiToast.success('禁言成功');
    })
    .catch((res) => {
      UiToast.fail(res.msg || '操作失败');
    });
};
const cancelForbid = (userId) => {
  request.api
    .get(`manage/recover/{access_token}/${room.getRoomId()}/${userId}`)
    .then((res) => {
      UiToast.success('解除禁言成功');
    })
    .catch((res) => {
      UiToast.fail(res.msg || '操作失败');
    });
};

const kickOut = (userId, minute) => {
  request.cryolite
    .post('api/v2/privileges/kick', {
      to_id: userId,
      room_id: room.getRoomId(),
      minutes: minute,
    })
    .then((res) => {
      UiToast.success('已被踢出');
    })
    .catch((res) => {
      UiToast.fail(res.msg || '操作失败');
    });
};

const imChat = (userId) => {
  let { userInfo } = getGlobalStore();
  if (userInfo.isAnchor || userInfo.isService || userInfo.isOperate) {
    ImApp.addChat(userId);
  } else {
    UiModal.confirm(
      '',
      '暂不支持发起聊天，下载最新的APP立即搭讪', // 删除 “和主播”文案，（某些情况下，对方不是主播）
      () => {
        window.open('/download.html', 'blank');
      },
      null,
      '下载 App',
    );
  }
};

// 查看个人档案
const redirectArchive = (userId) => {
  window.open(`/u/${userId}`);
};

const notifyUser = (options) => {
  request.cryolite
    .post({
      url: `/api/v5/star-notify/send?uid=${options.uid}&type=${options.type}`,
    })
    .then((res) => {
      UiToast.success(options.successTip || '已成功提示该用户');
    })
    .catch((res) => {
      UiToast.warn(res.msg || options.errTip || '提示用户失败');
    });
};

// 提示新人任务
const notifyNewUserTask = (userId) => {
  console.log('notifyNewUserTask userId', userId);
  notifyUser({
    uid: userId,
    type: 'new_user_task',
    successTip: '已提示该用户查看新人任务',
  });
};

// 提示首充礼包
const notifyNewUserFirstGift = (userId) => {
  notifyUser({
    uid: userId,
    type: 'new_user_first_gift',
    successTip: '已提该示用户查看首充礼包',
  });
};

// 戳一戳
const pokeAgain = (userId) => {
  request.cryolite
    .get({
      url: '/api/v1/accost/send_msg',
      data: { uid: userId, room_id: room.getRoomId() },
    })
    .then(() => {
      UiToast.success('已提示该用户查看戳一戳');
    })
    .catch((res) => {
      UiToast.warn(res.msg || '提示用户失败');
    });
};

export default {
  init,
  updateForbidTime,
  isForbid,
  forbid,
  cancelForbid,
  kickOut,
  imChat,
  redirectArchive,
  notifyNewUserTask,
  notifyNewUserFirstGift,
  pokeAgain,
  updateForbidStatus,
  handleHostOperator,
};
